/**
 * 레이아웃 전환 기준 (px)
 * `layout`: GNB 데스크톱 ↔ 햄버거·모바일 헤더, 탭 등 공통
 * 메뉴가 늘어나면 값을 올려 더 넓은 화면에서도 햄버거로 전환할 수 있음
 */
export const breakpoints = {
	layout: 1320,
} as const;

export type BreakpointsTypes = typeof breakpoints;
